import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
export default {
  name: "CategoryList",
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    AIList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      list: [],
      keyword: "",
      loading: true,
      emptyTag: "",
      keyList: {}
    };
  },
  created: function created() {
    this.getCategoryList();
  },
  methods: {
    hasTag: function hasTag(id) {
      return this.value.some(function (i) {
        return i.id === id;
      }) || this.AIList.some(function (i) {
        return i.id === id;
      }) ? "-" : "info";
    },
    selectTag: function selectTag(tag) {
      var arr = _toConsumableArray(this.value);
      var index = arr.findIndex(function (item) {
        return item.id === tag.id;
      });
      var otherIndex = this.AIList.findIndex(function (i) {
        return i.id === tag.id;
      });
      if (otherIndex > -1) {
        this.AIList.splice(otherIndex, 1);
        this.$emit("changeAssayValue", tag);
      } else {
        index > -1 ? arr.splice(index, 1) : arr.push(tag);
      }
      this.$emit("input", arr);
    },
    getCategoryList: function getCategoryList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _res$data;
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$api.getCommunityCategoryList({
                page: 1,
                limit: 100
              });
            case 1:
              res = _context.v;
              _this.list = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.list) || [];
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }
};